import { Component } from '@angular/core';
import { Button } from '../../../../shared/components/button/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-team',
  imports: [Button],
  templateUrl: './team.html',
  styleUrl: './team.scss'
})
export class Team {

  constructor(private router: Router) { }


  goToTeam() {
    this.router.navigate(['team']);
  }
}
